import * as bootstrap from 'bootstrap'

document.addEventListener('DOMContentLoaded', function () {

  // Allow header/main nav dropdowns on desktop to open via hover
  var dropdowns = document.querySelector('header').querySelectorAll('.dropdown');

  dropdowns.forEach(dropdown => {
    var dropdownToggle = dropdown.querySelector('.dropdown-toggle');
    var dropdownMenu = dropdownToggle.nextElementSibling;
    dropdown.addEventListener('mouseenter', () => {
      dropdownToggle.classList.add('show');
      dropdownToggle.setAttribute('aria-expanded', 'true');
      dropdownMenu.classList.add('show');
    })
    dropdown.addEventListener('mouseleave', () => {
      dropdownToggle.classList.remove('show');
      dropdownToggle.setAttribute('aria-expanded', 'false');
      dropdownMenu.classList.remove('show');
    })
  });

  // Animate transition for mobile menu toggle
  if (document.getElementById('mobile-menu')) {
    var offcanvas = document.getElementById('mobile-menu');

    offcanvas.addEventListener('show.bs.offcanvas', () => {
      document.querySelector('#mobile-menu-toggle').classList.add('is-active');
    });
    offcanvas.addEventListener('hide.bs.offcanvas', () => {
      document.querySelector('#mobile-menu-toggle').classList.remove('is-active');
    });
  }

  // Validate forms
  var forms = document.querySelectorAll('.needs-validation');

  Array.from(forms).forEach(form => {
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
      };
      form.classList.add('was-validated');
    }, false);
  });

  // Contact Us form adjustments
  document.addEventListener('wpcf7mailsent', function (event) {
    var form = document.querySelector('.wpcf7');
    var message = document.querySelector('.thank-you-message');
    form.remove();
    message.style.display = 'block';
  }, false);

  // Disclaimer jump links
  const symbols = [...document.querySelectorAll('sup')];
  const disclaimers = [...document.querySelectorAll('#footer-disclaimers li')];

  let disclaimerSymbols = disclaimers.map(disclaimer => {
    return disclaimer.dataset.symbol
  });

  symbols.forEach(symbol => {
    if (disclaimerSymbols.includes(symbol.innerHTML)) {
      symbol.setAttribute('tabindex', '0');
      symbol.classList.add('disclaimer');

      const jumpToDisclaimer = (sup) => {
        let disclaimer = disclaimers.find((symbol) => symbol.dataset.symbol === sup);
        let disclaimerWrapper = disclaimer.querySelector('span');
        let returnKey = disclaimer.querySelector('.return');
        returnKey.style.display = 'inline-block';
        disclaimerWrapper.classList.add('highlighted');
        disclaimer.scrollIntoView({ behavior: "instant" });
        returnKey.focus();
      }

      symbol.addEventListener('click', e => {
        jumpToDisclaimer(symbol.innerHTML);
        symbol.classList.add('current');
      })

      symbol.addEventListener('keypress', e => {
        if (e.key === 'Enter') {
          jumpToDisclaimer(symbol.innerHTML);
          symbol.classList.add('current');
        }
      })
    }
  })

  disclaimers.forEach(disclaimer => {
    let returnKey = disclaimer.querySelector('.return');

    jQuery(document).ready(function ($) {
      $(disclaimer).wrapInner('<span></span>');
    });

    const jumpReturn = () => {
      let symbols = [...document.body.getElementsByTagName('sup')];
      let symbolJump = symbols.find((symbol) => symbol.classList.contains('current'));
      let disclaimerWrapper = disclaimer.querySelector('span');
      returnKey.style.display = 'none';
      disclaimerWrapper.classList.remove('highlighted');
      symbolJump.scrollIntoView({ behavior: "instant" });
      symbolJump.focus();
    }

    if (returnKey) {
      returnKey.setAttribute('tabindex', '0');

      returnKey.addEventListener('click', e => {
        jumpReturn();
      })

      returnKey.addEventListener('keypress', e => {
        if (e.key === 'Enter') {
          jumpReturn();
        }
      })
    }
  })

  // Dynamic schema markup

  // Pages to use Product schema on
  var pageArray = [
    'page-template-business-line-of-credit',
    'page-template-business-term-loan',
    'page-template-business-funding',
    'page-template-short-term-loans',
    'page-template-small-business-loans',
    'page-template-loans-bad-credit',
    'page-template-loans-cleaning',
    'page-template-loans-commercial',
    'page-template-loans-contractors',
    'page-template-loans-credit-card',
    'page-template-loans-equipment',
    'page-template-loans-factoring',
    'page-template-loans-inventory',
    'page-template-loans-medical-practice',
    'page-template-loans-merchant-cash-advance',
    'page-template-loans-microloans',
    'page-template-loans-no-credit-check',
    'page-template-loans-restaurant-practice',
    'page-template-loans-retail',
    'page-template-loans-temporary',
    'page-template-loans-trucking',
    'page-template-loans-unsecured',
    'page-template-loans-working-capital'
  ];

  if (pageArray.some(page => document.body.classList.contains(page))) {
    // Get page data
    // Hero does not always use the 'hero' class, so this gets the first section
    var pageHero = document.getElementsByTagName('section')[0];

    var pageName = pageHero.querySelector('h1').innerText;
    var pageImage = pageHero.querySelector('.image img').src;
    var pageMetaDescription = document.querySelector('meta[name="description"]').content;

    var reviewTotal = ondeck_frontend.trustpilot ? ondeck_frontend.trustpilot.numberOfReviews.total.toString() : "0";

    // Set the review based on page
    // TODO: get number for these reviews & update this to use Trustpilot API data instead
    if (document.body.classList.contains('page-template-business-line-of-credit')) {
      var reviewName = 'Business Line of Credit- Fast, easy, generous, and professional';
      var reviewBody = 'Brett was my consultant throughout this loan process and he was fabulous. This company is punctual, professional, and so easy to work with. I was approved for a business loan to expand my business and they were very generous in their offering and I’m excited for this new chapter for my business! Highly recommended. The process was fast and very easy. Even though I have my credit frozen it was still a smooth process for me and low stress. Now I can use these funds to grow my business and get one step closer to a medical retirement! Yay.';
      var reviewDate = '2024-06-28';
      var reviewAuthor = 'Dee Dee';
    } else if (document.body.classList.contains('page-template-business-term-loan')) {
      var reviewName = 'Term Loans- Easy, Reliable, Quick Access to Funds';
      var reviewBody = 'First, they offer quick and convenient access to funds. On Deck has a fast online application process and can provide funding in as little as one business day, making it a great option for businesses that need capital quickly. Second, On Deck provides flexible loan options. They offer a variety of loan products, including term loans and lines of credit, with amounts ranging from $5,000 to $500,000. This flexibility allows businesses to choose the loan product that best fits their needs. Additionally, On Deck uses a technology-driven approach to underwriting, which allows them to assess the creditworthiness of a business based on a variety of factors beyond just a credit score. This can make it easier for businesses with less-than-perfect credit to qualify for a loan. Overall, On Deck is a great lending service because of its quick access to funds, flexible loan options, and technology-driven underwriting process, making it a valuable resource for businesses in need of capital.'
      var reviewDate = '2024-09-06';
      var reviewAuthor = 'David Gale';
    } else {
      var reviewName = 'Very Professional';
      var reviewBody = 'I decided to give OnDeck a try because they were recommended through QuickBooks Online. The process was extremely smooth and my rep Joe Gorman was fantastic to deal with. As a business with limited credit and bigger banks not approving us, OnDeck had us approved for a line of credit at close to their max they allow within 24 hours. I would highly recommend OnDeck to other business if they’re looking for credit/loans.'
      var reviewDate = '2024-10-31';
      var reviewAuthor = 'Ethan Hawes';
    }

    // Product schema
    const schema = {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": pageName,
      "image": pageImage,
      "description": pageMetaDescription,
      "brand": {
        "@type": "Brand",
        "name": "OnDeck"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5",
        "bestRating": "5",
        "worstRating": "1",
        "ratingCount": reviewTotal,
        "reviewCount": reviewTotal
      },
      "review": {
        "@type": "Review",
        "name": reviewName,
        "reviewBody": reviewBody,
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "datePublished": reviewDate,
        "author": { "@type": "Person", "name": reviewAuthor },
        "publisher": { "@type": "Organization", "name": "Trustpilot" }
      }
    };

    // Inject schema markup into HTML
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.classList.add('product-schema');
    script.innerHTML = JSON.stringify(schema);
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  if (document.body.classList.contains('post-type-archive-resource')) {
    if (typeof resourcePosts !== 'undefined') {
      // Merge post arrays from resource pages
      var posts = [].concat.apply([], [resourcePosts, smallBusinessFinancingPosts, runningABusinessPosts, insightsAndStoriesPosts]);

      // ListItem schema for resource archive page
      var schema = {
        "@context": "https://schema.org/",
        "@type": "ItemList",
        "description": "Our small business resource center features hundreds of informative articles written by industry experts. Topics range from building credit to small business insights and beyond.",
        "disambiguatingDescription": "Small Business Resource Center",
        "itemListOrder": "Descending",
        "numberOfItems": posts.length,
        "itemListElement": []
      };

      // Map posts to schema
      posts.forEach(function (post, i) {
        var postSchema = {
          "@type": "ListItem",
          "position": i + 1,
          "item": {
            "@type": "Article",
            "url": post.url,
            "headline": post.title,
            "datePublished": post.datePublished,
            "dateModified": post.dateModified,
            "image": {
              "@type": "ImageObject",
              "url": post.image
            },
            "publisher": {
              "type": "Organization",
              "name": "OnDeck",
              "url": "https://www.ondeck.com/"
            },
            "author": {
              "@type": "Person",
              "name": post.author,
              "url": post.authorURL
            }
          }
        }
        schema.itemListElement.push(postSchema);
      });

      // Inject schema markup into HTML
      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.innerHTML = JSON.stringify(schema);
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }

  // FAQ component schema markup
  const hasFAQ = document.querySelector('.faq-schema-list');
  if (hasFAQ) {
    var faqs = document.querySelectorAll('.faq-schema-item');
    var schema = {
      "@context": "https://schema.org/",
      "@type": "FAQPage",
      "mainEntity": []
    };

    faqs.forEach(function (faq, i) {
      var question = faq.querySelector('.faq-schema-question').innerText;
      var answer = faq.querySelector('.faq-schema-answer').innerText;

      var faqSchema = {
        "@type": "Question",
        "name": question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": answer
        }
      }
      schema.mainEntity.push(faqSchema);
    });

    // Inject schema markup into HTML
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.classList.add('faq-schema');
    script.innerHTML = JSON.stringify(schema);
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  // Exit intent modal
  const modalId = 'exit-modal';
  if (document.getElementById(modalId)) {
    let mouseMoved = false;
    let pageReady = false;

    function showExitModal() {
      if (
        mouseMoved &&
        pageReady &&
        !sessionStorage.getItem('modal.' + modalId)
      ) {
        new bootstrap.Modal('#' + modalId).show();
        sessionStorage.setItem('modal.' + modalId, '1');
      }
    }

    window.addEventListener('load', () => {
      setTimeout(() => {
        pageReady = true;
      }, 7000);
    });

    document.addEventListener('mousemove', () => {
      mouseMoved = true;
    });

    document.addEventListener('mouseout', (evt) => {
      if (evt.relatedTarget === null) {
        showExitModal();
      }
    });
  }
});

// Fix for known issue for Bootstrap modal focus & aria-hidden handling
// See: https://github.com/twbs/bootstrap/issues/41005

window.addEventListener('hide.bs.modal', () => {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
});

jQuery(document).ready(function ($) {
  
  // Init Bootstrap tooltips
  $("[data-bs-toggle='tooltip']").tooltip();

  // Reset disclaimer jumps
  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  $(window).on('resize scroll', function () {
    if (!$('footer').isInViewport()) {
      $('.disclaimer.return').css('display', 'none');
      $('sup').removeClass('current');
      $('li span').removeClass('highlighted');
    }
  });

  // Osano
  $('.cookie-preferences a').on('click', function () {
    Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')
  }
  );

  // Sliders
  document.querySelectorAll('.slider').forEach(function (sliderElem, sliderIndex) {
    const slider = sliderElem;
    const slides = slider.querySelectorAll('.slide');
    
    let navButtons = [];
    const sibling = slider.nextElementSibling;
    if (sibling && sibling.classList.contains('slider-nav')) {
      navButtons = sibling.querySelectorAll('button');
    }

    navButtons.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        const slideWidth = slides[0] ? slides[0].offsetWidth : 1;
        slider.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
      });
    });

    let isDown = false;
    let startX;
    let scrollLeft;

    const updateActiveSlide = () => {
      const scrollLeft = slider.scrollLeft;
      const slideWidth = slides[0] ? slides[0].offsetWidth : 1;
      const currentSlide = Math.round(scrollLeft / slideWidth);
      navButtons.forEach(btn => btn.classList.remove('active'));
      if (navButtons[currentSlide]) navButtons[currentSlide].classList.add('active');
    };

    updateActiveSlide();

    slider.addEventListener('scroll', () => {
      updateActiveSlide();
    });
    
    if (!('ontouchstart' in window)) {
      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        slider.classList.add('dragging');
        slider.classList.add('scroll-snap-none');
        e.preventDefault();
      });

      slider.addEventListener('mouseleave', () => {
        isDown = false;
        updateActiveSlide();
      });

      slider.addEventListener('mouseup', () => {
        isDown = false;
        const slideWidth = slides[0] ? slides[0].offsetWidth : 1;
        const currentSlide = Math.round(slider.scrollLeft / slideWidth);
        const sliderWidth = slider.offsetWidth;
        const slideCenterOffset = (slideWidth - sliderWidth) / 2;
        slider.scrollTo({ left: slideWidth * currentSlide - slideCenterOffset, behavior: 'smooth' });
        slider.classList.remove('dragging');
        slider.classList.remove('scroll-snap-none');
        updateActiveSlide();
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const currentX = e.pageX - slider.offsetLeft;
        const speed = (currentX - startX) * 2;
        slider.scrollLeft = scrollLeft - speed;
        updateActiveSlide();
      });
    };
  });

  // FAQ page search function
  if ($('body').hasClass('page-template-faqs')) {
    $(document).on('keyup search', '#faq-search', function () {
      var e = $(this).val().replace(/[^\w]/g, '').toLowerCase();
      e ? ($('.accordion').addClass('faq-search-active'), $('.accordion-item').removeClass('faq-search-match').filter(function () {
        var a = $(this).data('faq-plaintext');
        return a || (a = $(this).text().replace(/[^\w]/g, '').toLowerCase(), $(this).data('faq-plaintext', a)), a.match(e)
      }).addClass('faq-search-match')) : ($('.accordion').removeClass('faq-search-active'), $('.accordion-item.faq-search-match').removeClass('.faq-search-match'))
    })
  }

  // Contact Us page formatting fields to use floating labels
  if ($('body').hasClass('page-template-contact-us')) {
    $('.wpcf7-form-control-wrap').each(function () {
      var label = $(this).next('label').detach();
      var field = $(this).find('.form-control');
      $(this).append(label).addClass('form-floating');
      if (field) {
        field.val('');
      }
    })
  }

  // Resource author page
  if ($('body').hasClass('author')) {
    if (window.location.href.indexOf('/page/') > -1) {
      $('html, body').animate({ scrollTop: $('#articles').offset().top }, 0);
    }
  }

  // Short form (hero form)
  var heroForm = document.querySelector('.hero-form');

  if (heroForm) {
    // Auto-format phone and revenue fields
    const disallowNonNumericInput = (e) => {
      if (e.ctrlKey || e.metaKey) { return; }
      if (e.key !== undefined && e.key.length > 1) { return; }
      if (/[0-9]/.test(e.key)) { return; }
      e.preventDefault();
    };

    const formatToPhone = (e) => {
      const digits = e.target.value.replace(/\D/g, '').slice(-10);
      const areaCode = digits.substring(0, 3);
      const prefix = digits.substring(3, 6);
      const suffix = digits.substring(6, 10);

      if (digits.length > 6) { e.target.value = `(${areaCode}) ${prefix}-${suffix}`; }
      else if (digits.length > 3) { e.target.value = `(${areaCode}) ${prefix}`; }
      else if (digits.length > 0) { e.target.value = `(${areaCode}`; }
      else if (digits.length == 0) { e.target.value = ''; }
    };

    const formatToDollars = (e) => {
      const digits = e.target.value.replace(/\D/g, '');
      e.target.value = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      }).format(digits);
    };

    const phoneInput = document.querySelector('input[type="tel"]');
    if (phoneInput) {
      phoneInput.addEventListener('keydown', disallowNonNumericInput);
      phoneInput.addEventListener('keyup', formatToPhone);
    };

    const revenueInput = document.querySelector('#revenue');
    if (revenueInput) {
      revenueInput.addEventListener('keydown', disallowNonNumericInput);
      revenueInput.addEventListener('keyup', formatToDollars);
    };

    // Then remove the formatting on form submit
    const form = document.querySelector('.hero-form form');
    if (form) {
      form.addEventListener('submit', (e) => {
        if (form.checkValidity()) {
          phoneInput.value = phoneInput.value.replace(/\D/g, '');
          revenueInput.value = revenueInput.value.replace(/\D/g, '');
        }
      }, true);
    };

    // Lead Form Query String Population
    function getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");

      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");

        if (pair[0] == variable) {
          return pair[1];
        }
      }

      return "";
    }

    if (window.location.search) {
      document.querySelector('#first-name').value = getQueryVariable('firstName');
      document.querySelector('#last-name').value = getQueryVariable('lastName');
      document.querySelector('#email').value = getQueryVariable('emailAddress');
      document.querySelector('#phone').value = getQueryVariable('phoneNumber');
      document.querySelector('#revenue').value = getQueryVariable('annualRevenue');
    }
  }

  // Know Your Score / Free Business Credit Score landing page
  if ($('body').hasClass('page-template-campaign-score')) {
    // Auto-format phone and revenue fields
    const disallowNonNumericInput = (e) => {
      if (e.ctrlKey || e.metaKey) { return; }
      if (e.key !== undefined && e.key.length > 1) { return; }
      if (/[0-9]/.test(e.key)) { return; }
      e.preventDefault();
    };

    const formatToPhone = (e) => {
      const digits = e.target.value.replace(/\D/g, '').slice(-10);
      const areaCode = digits.substring(0, 3);
      const prefix = digits.substring(3, 6);
      const suffix = digits.substring(6, 10);

      if (digits.length > 6) { e.target.value = `(${areaCode}) ${prefix}-${suffix}`; }
      else if (digits.length > 3) { e.target.value = `(${areaCode}) ${prefix}`; }
      else if (digits.length > 0) { e.target.value = `(${areaCode}`; }
      else if (digits.length == 0) { e.target.value = ''; }
    };

    const formatToDollars = (e) => {
      const digits = e.target.value.replace(/\D/g, '');
      e.target.value = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      }).format(digits);
    };

    const phoneInput = document.querySelector('#mobile_phone');
    if (phoneInput) {
      phoneInput.addEventListener('keydown', disallowNonNumericInput);
      phoneInput.addEventListener('keyup', formatToPhone);
    };

    const revenueInput = document.querySelector('#annual_revenue');
    if (revenueInput) {
      revenueInput.addEventListener('keydown', disallowNonNumericInput);
      revenueInput.addEventListener('keyup', formatToDollars);
    };

    // Form submission
    const form = document.querySelector('.hero-form-score form');

    // Custom validity for the business entity type field
    // Sole proprietorships and general partnerships are not eligible
    function validateCompanyType() {
      const companyTypeInput = document.querySelector('#company_type');
      const feedback = companyTypeInput.parentElement.querySelector('.invalid-feedback');
      let message = '';
      if (companyTypeInput.validity.valueMissing) {
        message = 'Select a business entity type.';
        companyTypeInput.setCustomValidity(message);
      } else if ( companyTypeInput.value === 'sole-proprietorship' || companyTypeInput.value === 'general-partnership' ) {
        message = 'Sole proprietorships and general partnerships are not eligible.';
        companyTypeInput.setCustomValidity(message);
      } else {
        companyTypeInput.setCustomValidity('');
      }
      if (feedback) feedback.innerHTML = message;
    }

    // Validate on submit
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      validateCompanyType();

      const formSubmission = event.currentTarget;
      const formAction = 'https://cloud.e.ondeck.com/freebizscore';
      const formButton = form.querySelector('.submit-btn');
      const formButtonWidth = formButton.offsetWidth;

      // Remove any alerts at the end of the form (for re-submissions)
      const alerts = form.querySelectorAll('.alert');
      alerts.forEach(alert => alert.remove());

      // If form is not valid
      if (!form.checkValidity()) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const companyTypeInput = document.querySelector('#company_type');
        companyTypeInput.addEventListener('change', validateCompanyType);
      }

      // If form is fully valid
      if (form.checkValidity()) {
        // Hide the invalid form message if it's showing
        const formData = new FormData(formSubmission);

        const emailInput = document.querySelector('#email');
        const phoneInput = document.querySelector('#mobile_phone');
        const revenueInput = document.querySelector('#annual_revenue');

        // Remove non-numeric characters from phone and revenue fields
        if (phoneInput) {
          phoneInput.value = phoneInput.value.replace(/\D/g, '');
          formData.set('mobile_phone', phoneInput.value);
        }
        if (revenueInput) {
          revenueInput.value = revenueInput.value.replace(/\D/g, '');
          formData.set('annual_revenue', revenueInput.value);
        }

        // Custom event for Adobe that sends the email address field
        if (emailInput) {
          const customEvent = new CustomEvent('kys_email', { detail: { email: emailInput.value } });
          form.dispatchEvent(customEvent);
        }

        // Convert checkboxes to true/false values for Salesforce
        const checkboxes = form.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
          if (checkbox.checked) {
            checkbox.value = 'true';
          } else {
            checkbox.value = 'false';
          }
        });
        
        checkboxes.forEach(checkbox => {
          formData.set(checkbox.name, checkbox.value);
        });

        // Remove unnecessary Mixpanel fields
        // TODO: refactor/remove after parent theme decommissioning
        const keysToRemove = [];
        for (let [key] of formData.entries()) {
          if ( key.startsWith('converting_') || key.startsWith('original_') ) {
            keysToRemove.push(key);
          }
        }
        keysToRemove.forEach(key => formData.delete(key));

        // Adds a (hidden) field for Salesforce to tell them the form was submitted
        formData.set('submitted', 'true');

        // Adds hidden fields based on UTM parameters
        // Always sets all five UTM parameters, translating adid/adgroupid if present
        const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
        const params = new URLSearchParams(window.location.search);

        utmParams.forEach(key => {
          let value = params.get(key) || '';
          if (key === 'utm_term' && params.get('adid')) {
            value = params.get('adid');
          } else if (key === 'utm_content' && params.get('adgroupid')) {
            value = params.get('adgroupid');
          }
          formData.set(key, value);
        });

        // Disable submit button & add loading state
        formButton.setAttribute('disabled', 'disabled');
        formButton.style.minWidth = formButtonWidth + 'px';
        formButton.innerHTML = '<span class="spinner-border text-gray me-2" aria-hidden="true" style="width:1.5rem; height:1.5rem;"></span><span role="status">Loading</span>';
        
        // ReCAPTCHA vertification
        grecaptcha.reset();
        grecaptcha.ready(async () => {
          grecaptcha.execute('6LfifZMrAAAAAPeDirWeL1p6sthnVtDtWz1LCjVE', {action: 'submit'}).then(function(token) {

            // Sends the reCAPTCHA token to the server for verification
            $.ajax({
              url: ondeck_frontend.directoryurl + '/recaptcha.php',
              method: 'POST',
              data: { token: token },
              success: function(response) {
                // True response for proper reCAPTCHA scores
                if( response.score > 0.5 ) {
                  // Remove the reCAPTCHA response from the form data, as it's not needed
                  formData.delete('g-recaptcha-response');

                  // The POST request to Salesforce (formAction)
                  fetch(formAction, {
                    method: 'POST',
                    body: formData,
                  })
                  .then(response => {
                    if (response.ok) {
                      document.querySelector('.score-form').remove();
                      document.querySelector('.score-form-success').classList.remove('d-none');
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  })
                  .catch(error => {
                    console.error('Form submission error:', error);
                    const errorMsg = document.createElement('div');
                    errorMsg.className = 'alert alert-danger mt-4 mb-0';
                    errorMsg.textContent = 'Sorry, there was a problem submitting the form. Please reload the page and try again.';
                    form.appendChild(errorMsg);
                  });
                } else {
                  // False response for low reCAPTCHA scores
                  console.log('reCAPTCHA score too low:', response.score);
                  document.querySelector('.score-form').remove();
                  document.querySelector('.score-form-success').classList.remove('d-none');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              },
              error: function(xhr, status, error) {
                formButton.removeAttribute('disabled');
                formButton.innerHTML = 'Get Your Score';
                const errorMsg = document.createElement('div');
                errorMsg.className = 'alert alert-danger mt-4 mb-0';
                errorMsg.textContent = 'reCAPTCHA verification failed. Please try again.';
                form.appendChild(errorMsg);
              }
            });
          });
        });
      }
    }, true);
  }

  if ($('body').hasClass('page-template-campaign-direct-short')) {
    $('#source_code').on('input', function (e) {
      // Strip nonalphanumberic characters from reference code field
      $(this).val($(this).val().replace(/[^a-zA-Z0-9]/gi, ''));
    });

    // Validate reference code field while typing
    const form = document.querySelector('.needs-validation');
    const fields = form.querySelectorAll('input');

    Array.from(fields).forEach(field => {
      field.addEventListener('input', event => {
        if (field.checkValidity()) {
          form.classList.add('was-validated');
        }
      }, false);
    });
  }

  // Rewrite WP Generated Tables (resources)
  let tables = [...document.querySelectorAll(".resource-content table")];

  if (!tables) {
    //console.log("no tables")
  } else {
    tables.forEach((table) => {
      let headers,
        headerrow,
        cols,
        wrapper;

      //Create Table Head & Move first row to it
      table.prepend(document.createElement('thead'));
      headerrow = table.querySelector('tr:first-of-type');
      wrapper = table.querySelector('thead');
      wrapper.appendChild(headerrow);

      //Rewrite TDs to THs
      [...table.querySelectorAll('thead tr:first-of-type>td')].forEach(
        td => td.outerHTML = td.outerHTML
          .replace(/<td([^>]*)>/, '<th$1>')
          .replace(/<\/td>/, '</th>')
      );

      //Wrap text in tbody tds with div for styling
      [...table.querySelectorAll('tbody tr>td')].forEach(
        td => td.outerHTML = td.outerHTML
          .replace(/<td([^>]*)>/, '<td$1><div>')
          .replace(/<\/td>/, '</div></td>')
      );

      //Get table Headers
      headers = [...table.querySelectorAll('thead th')];

      //Assign Headers per Col
      headers.forEach((header, index) => {
        cols = [...table.querySelectorAll('tbody tr td:nth-of-type(' + (index + 1) + ')')];
        cols.forEach((col, index) => {
          col.dataset.label = header.innerText;
        });
      });
    });
  }

  // Bottom banner (currently on resource posts)
  if ($('body').hasClass('single-resource')) {
    const banner = document.querySelector('.banner-bottom');
    const footer = document.querySelector('footer');
    let bannerShown = false;

    function setFooterPadding() {
      if (footer && banner) {
        const bannerHeight = banner.offsetHeight + 16; // 16px for spacing
        footer.style.paddingBottom = banner.classList.contains('show') ? `${bannerHeight}px` : '';
      }
    }

    function showBannerOnScroll() {
      const scrollY = window.scrollY || window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight > 0 && scrollY / docHeight >= 0.25) {
        if (!bannerShown) {
          banner.classList.add('show');
          bannerShown = true;
          setFooterPadding();
        }
      } else {
        if (bannerShown) {
          banner.classList.remove('show');
          bannerShown = false;
          setFooterPadding();
        }
      }
    }

    window.addEventListener('scroll', showBannerOnScroll);
    window.addEventListener('resize', setFooterPadding);
    setFooterPadding();
  }

  // Orcolus dropdown navigation
  if (
    $('body').hasClass('page-template-ocrolus') ||
    $('body').hasClass('page-template-ocrolus-2023') ||
    $('body').hasClass('page-template-ocrolus-2024')) {
    // An alternative to Bootstrap's buggy scrollspy


    $('html').css('scroll-padding-top', '12rem');
    $(window).bind('scroll', function () {
      var currentTop = $(window).scrollTop();
      var elems = $('.scrollspy');

      elems.each(function (i) {
        var elemTop = $(this).offset().top;
        var elemBottom = elemTop + $(this).height();
        if (currentTop >= (elemTop - 230) && currentTop <= elemBottom) {
          var id = $(this).attr('id');
          var navElem = $('a[href="#' + id + '"]');
          var navText = $('a[href="#' + id + '"]').attr('data-report');
          navElem.addClass('active')
          navElem.parent().siblings().find('a').removeClass('active');
          $('.active-report').text(navText);
        }
      })
    });
  }
});
